import type { IconNode } from '../types';

/**
 * @name yarn-ball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNMTAgNmgxMCIgLz4KICA8cGF0aCBkPSJNMTQgMTBoNy44IiAvPgogIDxwYXRoIGQ9Im03LjIgMy4yIDEzLjYgMTMuNiIgLz4KICA8cGF0aCBkPSJtNCA2IDE1LjMgMTUuM2MuNC40IDEuMi43IDEuNy43aDEiIC8+CiAgPHBhdGggZD0ibTIuMiAxMC4yIDExLjYgMTEuNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/yarn-ball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const yarnBall: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M10 6h10', key: '1qtca6' }],
  ['path', { d: 'M14 10h7.8', key: '116vvu' }],
  ['path', { d: 'm7.2 3.2 13.6 13.6', key: 'c7s9ub' }],
  ['path', { d: 'm4 6 15.3 15.3c.4.4 1.2.7 1.7.7h1', key: 'iue9wq' }],
  ['path', { d: 'm2.2 10.2 11.6 11.6', key: '18k6pp' }],
];

export default yarnBall;
